var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',_vm._g(_vm._b({style:({ maxWidth: _vm.maxWidth }),attrs:{"controls":"","controlsList":"nodownload"},on:{"canplaythrough":function($event){return _vm.$emit('load')}}},'video',_vm.$attrs,false),_vm.$listeners),[_c('source',{attrs:{"preload":"auto","src":_vm.src,"type":"video/mp4"}}),_vm._v(" הדפדפן שלך אינו תומך ברכיב הוידאו ")])
}
var staticRenderFns = []

export { render, staticRenderFns }